import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import NotesCard from '~/components/notesCard/notesCard';
import TitleBar from '~/components/titleBar/titleBar';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import CustomerDetailCard from '~/components/customerDetailCard/customerDetailCard';
import CustomerSummaryCard from '~/components/customerSummaryCard/customerSummaryCard';
import CustomerContactDetailsCard from '~/components/customerContactDetailsCard/customerContactDetailsCard';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getCustomerQuery = gql`
  query customer($id: Int!) {
    customer(id: $id) {
      id
      name
      contactName
      birthDate
      streetAddress
      streetAddress2
      suburb
      city
      country
      postcode
      fin
      email
      phone
      notes
      xero
    }
  }
`;

export class Customer extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Weird bug that I couldn't figure out - we call the `onCompleted` prop which, in most cases I've built,
      // updates state on the parent which causes a rerender of this child. In most cases this is fine but for
      // some reason in this components case the rerender would cause a refetch which would cause `onCompleted`
      // to fire a shitload of times causing a bug. So, this stops that. Weird, but it works
      return false;
    }

    return true;
  }

  renderTitleButtons = customer => {
    const customerId = this.props.match.params.customerId;
    return (
      <Fragment>
        <Link className="pr3" to={`/customers/${customerId}/order`}>
          <Button color="secondary">New Order</Button>
        </Link>
        <Link to={`/customers/${customerId}/edit`}>
          <Button color="primary">Edit</Button>
        </Link>
      </Fragment>
    );
  };

  render() {
    const { onCompleted, id } = this.props;
    return (
      <Query query={getCustomerQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { customer } = data;
          return (
            <Fragment>
              <URLParamBanner name="customer" />
              <TitleBar
                headerClassName="flex items-center"
                back="/customers"
                backText="Customers"
                title={customer.name}
                button={this.renderTitleButtons(customer)}
              />
              <div className="flex content">
                <div className="flex-2 mr4">
                  <CustomerDetailCard {...customer} className="mb4" />
                  <CustomerContactDetailsCard {...customer} />
                </div>
                <div className="flex-1">
                  <CustomerSummaryCard {...customer} />
                  <NotesCard className="mt4" notes={customer.notes} />
                </div>
              </div>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(Customer);



// WEBPACK FOOTER //
// ./src/containers/customer/customer.jsx